import React, { createContext, useState } from 'react';

export const NewSelectionSearchFiltersStateContext = createContext();

const INITIAL_STATE = {
  filterObject: {},
  showFilters: true
};

const NewSelectionSearchFiltersContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <NewSelectionSearchFiltersStateContext.Provider value={stateHook}>
      {children}
    </NewSelectionSearchFiltersStateContext.Provider>
  );
};

export default NewSelectionSearchFiltersContextProvider;